import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;

  padding: 30px 25px;
  border-radius: 15px;
  background-color: #fff;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.27);

  @media(max-width: 992px) {
    height: auto;
    padding: 20px;
    margin: 0 30px 20px;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media(max-width: 720px) {
    gap: 10px;
  }

  div {
    div {
      display: flex;
      align-items: center;
      flex-direction: row;
    }
  }
`;

export const LogoLingo = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 3px;
`;

export const PlanName = styled.span`
  margin-left: 10px;
  
  font-size: 20px;
  font-weight: 700;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
`;

export const WrapperLanguage = styled.div`
  display: flex;
  gap: 2px;
  margin: 5px 0 10px;

  @media(max-width: 992px) {
    margin: 0;
  }
`;

export const DescriptionHeader = styled.span`
  font-size: 13px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
`;

export const WrapperPriceCard = styled.div`
  @media(min-width: 992px) {
    display: none;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 3px;

    sub {
      color: #3DA8FE;
      font-size: 15px;
      font-weight: 700;
      text-transform: lowercase;
      font-family: 'Montserrat', sans-serif;
      margin-bottom: -2px;

      &:first-child {
        margin-right: 5px;
        margin-bottom: -2px;
        text-transform: capitalize;
      }
    }

    span {
      color: #3DA8FE;
      font-size: 24px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
    }
  }
`;

export const TextPriceCard = styled.h2`
  line-height: 18px;
  color: #3DA8FE;
  font-size: 16px;
  font-weight: 400;
  text-align: right;
  font-family: 'Montserrat', sans-serif;
`;

export const DescriptionCard = styled.div`
  width: 330px !important;
  display: flex;
  flex-direction: column;
  margin: 20px 0;

  @media(max-width: 992px) {
    display: none;
  }
`;

export const ItemDescriptionCard = styled.div`
  display: flex;
  align-items: center;

  margin: 3px 0;
  gap: 7px;

  span {
    color: #222222;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  svg {
    padding-right: 7px;
  }

  img {
    width: 40px;
    height: 18px;
  }
`;

export const Separator = styled.div`
  width: 100%; 
  height: 1px; 
  margin-bottom: 20px;
  background-color: #ccc;

  @media(max-width: 992px) {
    display: none;
  }
`;

export const WrapperLogoParther = styled.div`
  width: 100%; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;

  p {
    font-size: 11px;
    color: #222; 
    padding-bottom: 10px;
  }

  img {
    width: auto;
    max-width: 160px;
    max-height: 50px;
  }

  @media(max-width: 992px) {
    display: none;
  }
`;

export const WrapperLogoPartherHeader = styled.div`
  width: 100%; 
  display: flex;
  margin: 20px 0 0px;

  @media(min-width: 992px) {
    display: none;
  }

  img {
    width: auto;
    max-width: 160px;
    max-height: 50px;
  }
`;

export const WrapperPrice = styled.div`
  @media(max-width: 992px) {
    display: none;
  }

  div {
    display: flex;
    align-items: flex-end;
    margin-top: 3px;

    sub {
      color: #3DA8FE;
      font-size: 15px;
      font-weight: 700;
      text-transform: lowercase;
      font-family: 'Montserrat', sans-serif;
      margin-bottom: 3px;

      &:first-child {
        margin-right: 5px;
        text-transform: capitalize;
      }
    }

    span {
      color: #3DA8FE;
      font-size: 24px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
    }
  }
`;

export const TextPrice = styled.h2`
  line-height: 20px;
  color: #3DA8FE;
  font-size: 18px;
  font-weight: 400;
  font-family: 'Montserrat', sans-serif;
`;
